import Vue from 'vue'

let theming = {
  methods: {
    _setLogo: (imageURL, configEntry) => {
      let images = JSON.parse(localStorage.getItem('images'))

      if (!configEntry) {
        let image = images.filter(image => image.key === 'logo')
        return image[0].value
      }



      if (images) {
        let image = images.filter(image => image.key === configEntry)

        if (image.length <= 0) {
          return imageURL
        }

        return image[0].value
      } else {
        return imageURL
      }
    }
  }
}

export default theming